import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { ToastService } from '../toast/toast.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class InternetService {
  private isBrowser: boolean;

  // public onlineEvent: Observable<Event> = fromEvent(window, 'online');
  // public offlineEvent: Observable<Event> = fromEvent(window, 'offline');
  public subscriptions: Subscription[] = [];
  public showProgressbar: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private _toastService: ToastService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }


  public subscribeInternetEvents(): void {
    if (!this.isBrowser) {
      return; // ✅ SSR safe
    }

    const onlineEvent$ = fromEvent(window, 'online');
    const offlineEvent$ = fromEvent(window, 'offline');

    this.subscriptions.push(
      onlineEvent$.subscribe(() => {
        this._toastService.clear();
        this._toastService.showSuccess('Back to online');
      })
    );

    this.subscriptions.push(
      offlineEvent$.subscribe(() => {
        this._toastService.clear();
        this._toastService.showError(
          'Connection lost! You are not connected to internet'
        );
      })
    );
  }

  public unsubscribeInternetEvents(): void {
    if (!this.isBrowser) {
      return;
    }

    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions = [];
  }
}
